import {
    NEW_CERTIFICADO_DIGITAL_CADASTRO_SUCCESS,
    CANCEL_CERTIFICADO_DIGITAL_CADASTRO_RAPIDO,
    CANCEL_CERTIFICADO_DIGITAL_CADASTRO_RAPIDO_SUCCESS,
    TABLE_CERTIFICADO_DIGITAL_CADASTRO_PENDING,
    TABLE_CERTIFICADO_DIGITAL_CADASTRO_SUCCESS,
    TABLE_CERTIFICADO_DIGITAL_CADASTRO_FAILURE,
    LIST_CERTIFICADO_DIGITAL_CADASTRO_PENDING,
    LIST_CERTIFICADO_DIGITAL_CADASTRO_SUCCESS,
    LIST_CERTIFICADO_DIGITAL_CADASTRO_FAILURE,
    FIND_CERTIFICADO_DIGITAL_CADASTRO_PENDING,
    FIND_CERTIFICADO_DIGITAL_CADASTRO_SUCCESS,
    FIND_CERTIFICADO_DIGITAL_CADASTRO_FAILURE,
    DELETE_CERTIFICADO_DIGITAL_CADASTRO_PENDING,
    DELETE_CERTIFICADO_DIGITAL_CADASTRO_SUCCESS,
    DELETE_CERTIFICADO_DIGITAL_CADASTRO_FAILURE,
    CREATE_CERTIFICADO_DIGITAL_CADASTRO_PENDING,
    CREATE_CERTIFICADO_DIGITAL_CADASTRO_SUCCESS,
    CREATE_CERTIFICADO_DIGITAL_CADASTRO_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function certificadoDigitalCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_CERTIFICADO_DIGITAL_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido ?? false,
            }
        case LIST_CERTIFICADO_DIGITAL_CADASTRO_PENDING:
        case FIND_CERTIFICADO_DIGITAL_CADASTRO_PENDING:
        case DELETE_CERTIFICADO_DIGITAL_CADASTRO_PENDING:
        case CREATE_CERTIFICADO_DIGITAL_CADASTRO_PENDING:
        case TABLE_CERTIFICADO_DIGITAL_CADASTRO_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CANCEL_CERTIFICADO_DIGITAL_CADASTRO_RAPIDO:
        case CANCEL_CERTIFICADO_DIGITAL_CADASTRO_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_CERTIFICADO_DIGITAL_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_CERTIFICADO_DIGITAL_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_CERTIFICADO_DIGITAL_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_CERTIFICADO_DIGITAL_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_CERTIFICADO_DIGITAL_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_CERTIFICADO_DIGITAL_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_CERTIFICADO_DIGITAL_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_CERTIFICADO_DIGITAL_CADASTRO_SUCCESS:
        case CREATE_CERTIFICADO_DIGITAL_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_CERTIFICADO_DIGITAL_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { certificadoDigitalCadastroReducer };